var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-0 ma-4 mt-0"},[_c('v-card-title',{staticClass:"justify-center"},[_c('h3',[_vm._v("Agent Preferences")])]),_c('v-card-actions',{staticClass:"justify-center"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }